import { useState, useEffect } from 'react';
export default function useIsOnScreen(ref) {
    var _a = useState(false), isOnScreen = _a[0], setIsOnScreen = _a[1];
    var observer = new IntersectionObserver(function (_a) {
        var entry = _a[0];
        return setIsOnScreen(entry.isIntersecting);
    });
    useEffect(function () {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return function () {
                observer.disconnect();
            };
        }
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
    return isOnScreen;
}
